/* tslint:disable */
require('./BannerWp.module.css');
require('../../../../node_modules/react-image-gallery/styles/css/image-gallery-no-icon.css');
const styles = {
  'image-gallery': 'image-gallery_e8eee081',
  'fullscreen-modal': 'fullscreen-modal_e8eee081',
  'image-gallery-content': 'image-gallery-content_e8eee081',
  fullscreen: 'fullscreen_e8eee081',
  'image-gallery-slide': 'image-gallery-slide_e8eee081',
  'image-gallery-slide-wrapper': 'image-gallery-slide-wrapper_e8eee081',
  left: 'left_e8eee081',
  right: 'right_e8eee081',
  'image-gallery-fullscreen-button': 'image-gallery-fullscreen-button_e8eee081',
  'image-gallery-play-button': 'image-gallery-play-button_e8eee081',
  'image-gallery-left-nav': 'image-gallery-left-nav_e8eee081',
  'image-gallery-right-nav': 'image-gallery-right-nav_e8eee081',
  'image-gallery-slides': 'image-gallery-slides_e8eee081',
  center: 'center_e8eee081',
  'image-gallery-description': 'image-gallery-description_e8eee081',
  'image-gallery-bullets': 'image-gallery-bullets_e8eee081',
  'image-gallery-bullets-container': 'image-gallery-bullets-container_e8eee081',
  'image-gallery-bullet': 'image-gallery-bullet_e8eee081',
  active: 'active_e8eee081',
  'image-gallery-thumbnails-wrapper': 'image-gallery-thumbnails-wrapper_e8eee081',
  'image-gallery-thumbnails': 'image-gallery-thumbnails_e8eee081',
  'image-gallery-thumbnail': 'image-gallery-thumbnail_e8eee081',
  'image-gallery-thumbnails-container': 'image-gallery-thumbnails-container_e8eee081',
  'image-gallery-thumbnail-label': 'image-gallery-thumbnail-label_e8eee081',
  'image-gallery-index': 'image-gallery-index_e8eee081',
};

export default styles;
/* tslint:enable */